import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {findDOMNode} from 'react-dom';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {getDOMNode, getDOMNodes, toPX} from 'utils';

export default class EntityType extends Component {
    static propTypes = {
        entityType: ImmutablePropTypes.map.isRequired,
        expanded: PropTypes.bool.isRequired,
        children: PropTypes.node.isRequired,
        tabIndex: PropTypes.number.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.node = findDOMNode(this);
        this.content = getDOMNode('.cielo24-vwrap-content', this.node);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.entityType !== this.props.entityType
            || nextProps.expanded !== this.props.expanded
            || nextProps.children !== this.props.children
            || nextProps.tabIndex !== this.props.tabIndex
            || nextProps.onClick !== this.props.onClick;
    }

    componentDidUpdate() {
        this.expandChildren();
    }

    expandChildren() {
        let contentHeight = 0;

        if (this.props.expanded) {
            const container = this.node.parentNode;
            const headersHeight = getDOMNodes('.cielo24-vwrap-entity-type > .cielo24-vwrap-header', container)
                .reduce((s, h) => s + h.offsetHeight, 0);
            const itemsHeight = getDOMNodes('.cielo24-vwrap-entity', this.content)
                .reduce((s, e) => s + e.offsetHeight, 0);

            contentHeight = Math.min(container.clientHeight - headersHeight, itemsHeight);
            this.content.style.overflow = itemsHeight > contentHeight ? 'auto' : 'hidden';
        }

        this.content.style.height = toPX(contentHeight);
    }

    @autobind
    handleClick() {
        this.props.onClick(this.props.entityType);
    }

    render() {
        const {entityType, expanded, tabIndex, children} = this.props;
        const count = entityType.get('count');
        const className = classNames('cielo24-vwrap-entity-type', {'cielo24-vwrap-expanded': expanded});
        const speedIndex = Math.min(2, Math.floor(count / 3)) + 1;

        const countDisplay = <span className='cielo24-vwrap-pill'>{count}</span>;
        const toggleIcon = <i className='cielo24-vwrap-icon cielo24-vwrap-icon-chevron-up-thin' aria-hidden={true} />;

        return (
            <div className={className}>
                <button type='button' className='cielo24-vwrap-header' onClick={this.handleClick} tabIndex={tabIndex}>
                    <span className='cielo24-vwrap-display'>{i18next.t(entityType.get('displayAsPlural'))}</span>
                    {this.props.expanded ? toggleIcon : countDisplay}
                </button>
                <div className={`cielo24-vwrap-content cielo24-vwrap-speed-${speedIndex}`}>
                    <div className='cielo24-vwrap-content-container'>{children}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/entity-menu/entity-type.js